import {BaseModel} from "../base";
import {BBModel} from "../../bb_model";
import {memberPurchase} from "../../services/member_purchase";

class MemberPurchaseModel extends BaseModel {

    constructor(data) {
        super(data);

        this.created_at = moment.parseZone(this.created_at);
        if (this.time_zone) {
            this.created_at.tz(this.time_zone);
        }
    }

    getItems() {
        return new Promise((resolve, reject) => {
            this._data.$get('purchase_items').then(function (items) {
                this.items = Array.from(items).map(item =>
                    new BBModel.Member.PurchaseItem(item));
                return resolve(this.items);
            });
        });
    }

    static $query(member, params) {
        return memberPurchase.query(member, params);
    }
}

export {
    MemberPurchaseModel
}